import { render } from "./index.vue?vue&type=template&id=cbbda0de&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cbbda0de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cbbda0de"

export default script